import { useRightSidebarContext } from '@confluence/page-layout-context';

export const useRightSidebarCompensation = () => {
	const { sidebars } = useRightSidebarContext();

	return sidebars.reduce((accumulator, sidebar) => {
		if (sidebar.isCollapsed || sidebar.isMinimized) {
			return accumulator;
		}
		return accumulator + sidebar.width;
	}, 0);
};
